import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import React from 'react';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import useUnreadNotificationBgFetcher from 'src/modules/notification/hooks/useUnreadNotificationBgFetcher';
import { InitialRouteName } from './config';
import { getNavEntries } from './primaryNav/registry';
import usePrimaryNavContext from './primaryNav/usePrimaryNavContext';
import { RootStack } from './RootNavigation';
export const RootTab = createBottomTabNavigator();
const TabNavigator = () => {
    const [{ theme, deviceType, dimensions }] = useTheme(stylesGenerator);
    const ctx = usePrimaryNavContext();
    useUnreadNotificationBgFetcher();
    return (React.createElement(RootTab.Navigator, { screenOptions: {
            headerShown: false,
            tabBarActiveTintColor: theme.palette.primary.dark,
            tabBarInactiveTintColor: theme.palette.typography.primary,
            tabBarStyle: deviceType.isDesktop
                ? { display: 'none' }
                : {
                    backgroundColor: theme.palette.background.main,
                    paddingBottom: dimensions.safeAreaInsets.bottom,
                    height: 48 + dimensions.safeAreaInsets.bottom,
                },
            tabBarAllowFontScaling: true,
            tabBarHideOnKeyboard: true,
            tabBarShowLabel: !deviceType.isPhone,
        }, initialRouteName: InitialRouteName }, getNavEntries(ctx, 'tab').map(entry => (React.createElement(React.Fragment, { key: entry.id }, entry.renderTabRoutes(ctx))))));
};
export const stylesGenerator = createThemedStyle(() => ({
    drawerItem: {
        marginHorizontal: 0,
        marginVertical: 0,
        borderRadius: 0,
        paddingVertical: 4,
    },
}));
export const renderTabStackRoutes = ({}) => {
    return (React.createElement(RootStack.Screen, { name: "Tabs", component: TabNavigator }));
};
